import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const CanBusLoadCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-can-bus-load-calculator" />;

export default CanBusLoadCalculatorGuidePage;
